import React, { useState, useEffect } from "react";
import { navigate } from "gatsby";
import { Helmet } from "react-helmet";
import queryString from "query-string";
import { GoogleSpreadsheet } from "google-spreadsheet";

import "bootstrap/dist/css/bootstrap.min.css";
import "../styles/styles.css";

import { credentials, sheetId } from "../constants/credentials";
import * as SCREENS from "../constants/screens";
import * as ADMINS from "../constants/admins";
import Welcome from "../components/welcome";
import Administrators from "../components/administrators";
import Name from "../components/name";
import Credit from "../components/credit";
import Finality from "../components/finality";
import Phone from "../components/phone";
import Results from "../components/results";
import Sidebar from "../components/sidebar";
import TypeInto from "../components/type-into";
import ServopaOptions from "../components/servopa/options";
import ServopaMpar from "../components/servopa/servopa_mpar"

export default function IndexPage({ location }) {
  const urlFrom = queryString.parse(location.search).from;
  const [sidebar, setSidebar] = useState(false);
  const [data, setData] = useState({
    screen: SCREENS.WELCOME,
    associateMode: false,
    redirected: false,
    name: "",
    phone: "",
    administrator: null,
    finality: null,
    category: null,
    credit: 0,
    creditMessage: "",
    results: [],
    formURI: ""
  });

  const getLocalNameAndPhone = () => {
    const name = localStorage.getItem("name");
    const phone = localStorage.getItem("phone");

    return { name, phone };
  };

  useEffect(() => {
    const { name, phone } = getLocalNameAndPhone();
    setData({
      ...data,
      name: name === null ? "" : name,
      phone: phone === null ? "" : phone,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const { name, phone } = getLocalNameAndPhone();

    if (
      urlFrom === ADMINS.BB_ABBV ||
      urlFrom === ADMINS.CAIXA_ABBV ||
      urlFrom === ADMINS.ITAU_ABBV
    ) {
      const administrator =
        urlFrom === ADMINS.BB_ABBV
          ? ADMINS.BB_NAME
          : urlFrom === ADMINS.CAIXA_ABBV
            ? ADMINS.CAIXA_NAME
            : urlFrom === ADMINS.ITAU_ABBV
              ? ADMINS.ITAU_NAME
              : null;

      setData({
        ...data,
        name: name === null ? "" : name,
        phone: phone === null ? "" : phone,
        redirected: true,
        associateMode: false,
        administrator: administrator,
        screen: SCREENS.NAME,
      });

      // sendDataToSheet(
      //   name,
      //   phone,
      //   false,
      //   true,
      //   administrator,
      //   "Iniciou simulação"
      // );

      navigate("/");
    } else if (urlFrom !== undefined) {
      navigate("/");
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urlFrom]);

  if (process.env.NODE_ENV === "development") console.log({ ...data });

  useEffect(() => {
    function handleResize() {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // async function sendDataToSheet(name, phone, associate, landing, adm, action) {
  //   var private_key = credentials.private_key.replace(/\\n/g, "\n");
  //   const file = new GoogleSpreadsheet(sheetId);
  //   await file.useServiceAccountAuth({
  //     client_email: credentials.client_email,
  //     private_key: private_key,
  //   });
  //   await file.loadInfo();

  //   const sheet = file.sheetsByIndex[0];
  //   await sheet.addRow({
  //     nome: name === null ? "" : `${name.toUpperCase()}`,
  //     telefone: phone === null ? "" : `${phone}`,
  //     parceiro: associate,
  //     landing: landing,
  //     adm: typeof adm === "string" ? adm.toUpperCase() : adm,
  //     ação: action,
  //     data: new Date().toLocaleString("pt-br"),
  //   });
  // }

  function openSidebar() {
    setSidebar(true);
  }

  function closeSidebar() {
    setSidebar(false);
  }

  const dataManager = {
    data: data,
    setData: setData,
    // sendDataToSheet: sendDataToSheet,
  };
  const sidebarManager = {
    sidebar: sidebar,
    openSidebar: openSidebar,
    closeSidebar: closeSidebar,
  };

  return (
    <div className="main-screen">
      <Helmet>
        <meta charSet="utf-8" />
        <title>Simulador - Guerra Consórcios</title>
      </Helmet>
      {data.screen === SCREENS.WELCOME ? (
        <Welcome dataManager={dataManager} />
      ) : data.screen === SCREENS.NAME ? (
        <Name dataManager={dataManager} sidebarManager={sidebarManager} />
      ) : data.screen === SCREENS.ADMINISTRATORS ? (
        <Administrators
          dataManager={dataManager}
          sidebarManager={sidebarManager}
        />
      ) : data.screen === SCREENS.TYPE_INTO ? (
        <TypeInto dataManager={dataManager} sidebarManager={sidebarManager} />
      ) : data.screen === SCREENS.FINALITY ? (
        <Finality dataManager={dataManager} sidebarManager={sidebarManager} />
      ) : data.screen === SCREENS.CREDIT ? (
        <Credit dataManager={dataManager} sidebarManager={sidebarManager} />
      ) : data.screen === SCREENS.PHONE ? (
        <Phone dataManager={dataManager} sidebarManager={sidebarManager} />
      ) : data.screen === SCREENS.RESULTS ? (
        <Results dataManager={dataManager} sidebarManager={sidebarManager} />
      ) : data.screen === SCREENS.SERVOPA_OPTIONS ? (
        <ServopaOptions dataManager={dataManager} sidebarManager={sidebarManager} />
      ) : data.screen === SCREENS.SERVOPA_MPAR ? (
        <ServopaMpar dataManager={dataManager} sidebarManager={sidebarManager} />
      ) : null}
      <Sidebar sidebarManager={sidebarManager} />
    </div>
  );
}
